export default "__VITE_ASSET__fa4cfab7__"